
/* ============================================================
namespace
============================================================ */

window.mypage = window.mypage||{};
window.mypage.function = window.mypage.function||{};
window.mypage.state = window.mypage.state||{};

/* ====================  ==================== */

window.mypage.state.breakPoint = 900;
window.mypage.state.drawerShow = false;
window.mypage.state.screen = "narrow";

/* ============================================================
スクリーンサイズチェック
============================================================ */

$(window).on("load resize", function() {
  var wW = $(window).innerWidth();
  if (wW > window.mypage.state.breakPoint) {
    if (window.mypage.state.screen === "wide") { return; }
    window.mypage.state.screen = "wide";
  } else {
    if (window.mypage.state.screen === "narrow") { return; }
    window.mypage.state.screen = "narrow";
  }
});

/* ============================================================
Scroll Magic (palalax)
============================================================ */
(function () {
  class ScrollFade {
    constructor() {
      this.ANIMATION_CLASS = 'is-animation';

      let $section = document.querySelectorAll('.js-scroll-magic:not(.is-animation)');
      if ($section.length === null) {
        return;
      }
      let controller = new ScrollMagic.Controller();
      for (let i = 0, len = $section.length; i < len; i=(i+1)|0) {
        let scene = new ScrollMagic.Scene({
            triggerElement: $section[i],
            triggerHook: 'onEnter',
            reverse: false,
            offset: 50
          })
          .addTo(controller);
        scene.on('enter', () => {
          $section[i].classList.add(this.ANIMATION_CLASS);
        });
        scene.on('end', () => {
          scene.destroy(true);
        });
      }
    }
  }

  new ScrollFade();
})();

/* ============================================================
drawer
============================================================ */
/*
$(function(){

  const $header = $(".l-header"),
    $drawer = $(".l-drawer"),
    $drawerButton = $(".js-toggleDrawer"),
    $overlay = $(".js-drawerOverlay");

  window.mypage.function.showDrawer = function(parent, drawer){
    $(parent).addClass('is-show');
    $(drawer).addClass('is-show');
    $overlay.addClass('is-show');
    window.mypage.state.drawerShow = true;
  };

  window.mypage.function.hideDrawer = function(parent, drawer){
    $(parent).removeClass('is-show');
    $(drawer).removeClass('is-show');
    $overlay.removeClass('is-show');
    window.mypage.state.drawerShow = false;
  };

  $("body").addClass("is-ready");

  $drawerButton.on("click", function(){
    if (window.mypage.state.drawerShow) {
      window.mypage.function.hideDrawer($header, $drawer);
    } else {
      window.mypage.function.showDrawer($header, $drawer);
    }
  });

  $overlay.on("click", function(){
    window.mypage.function.hideDrawer($header, $drawer);
  });

});
*/

/* ============================================================
scroll
============================================================ */

(function(){

  const
    $target = $('a[href^="#"],a[href^="/#"]'),
    locationHref = location.href,
    urlHash = location.hash,
    scrollTime = 1000,
    scrollEasing = "swing",
    scrollOffsetYWide = -100,
    scrollOffsetYNarrow = -100;

  function scrollToAnker(hash) {
    const
      target = $(hash),
      position = target.offset().top;
    let offset = scrollOffsetYNarrow;

    if (window.mypage.state.screen === "wide") {
      offset = scrollOffsetYWide;
    }

    $("html,body").stop().animate({scrollTop: position + offset }, scrollTime, scrollEasing);
  }

  if (urlHash) {
    if ($(urlHash).length) {
      $(function() {
        $("html,body").stop().animate({ scrollTop: 0 }, 0);
      });
      $(window).on("load", function(){
        setTimeout(function() {
          scrollToAnker(urlHash);
        }, 10);
      });
    }
  }

  $target.on("click", function(){
    const
      id = $(this).attr("href").split("#"),
      hash = id[id.length-1];
    scrollToAnker("#" + hash);
  });

})();

/* ============================================================

============================================================ */

$(function(){

  const $drawerButton = $(".js-toggleFooterList");

  $drawerButton.on("click", function(){
    const $targetList = $(this).next(".l-footerSubNavList");
    $targetList.slideToggle(300);
    $(this).toggleClass("is-open");
  });

});

/* ============================================================

============================================================ */

(function () {
  $(function(){
    if ( !navigator.share ) {
      $('.js-webShareParent').hide()
    }
  })
  
  const shareData = {
    url: location.href,
    title: document.title,
    text: document.title,
  }
  
  const btn = document.querySelector('.js-webShare');
  
  $(function(){
    if ( !navigator.share ) {
      $('.js-webShare').hide()
    }
  })
  
  // Must be triggered some kind of "user activation"
  if (btn) {
    btn.addEventListener('click', async () => {
      try {
        await navigator.share(shareData)
      } catch(err) {
      }
    });
  }
  
})();

